import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import TextView from "./TextView";
import IconView from "./IconView";
import { BuildContext } from "../classes/BuildContext";

export interface IconViewWithTextProps extends BaseUIProps {
  key?: string;
  icon: ui.IconData;
  value: string;
  size?: number;
}

class _IconViewWithTextState extends ObservableComponent<IconViewWithTextProps> {
  static defaultProps = { icon: null, value: "", size: 24.0 };
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public constructor(props: IconViewWithTextProps) {
    super(props);

    this.initState();
  }
  public get icon(): ui.IconData {
    return this.props.icon;
  }
  public get value(): string {
    return this.props.value;
  }
  public get size(): number {
    return this.props.size;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["icon", "size", "value"], this.rebuild);
  }
  public componentDidUpdate(prevProps: IconViewWithTextProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.icon !== this.props.icon) {
      this.fire("icon", this);
    }

    if (prevProps.value !== this.props.value) {
      this.fire("value", this);
    }

    if (prevProps.size !== this.props.size) {
      this.fire("size", this);
    }
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Row({
      children: [
        IconView({
          size: this.size,
          icon: this.icon,
          color: cStyle.c4,
          className: "x77c",
          key: "0",
        }),
        TextView({
          data: this.value,
          style: new ui.TextStyle({
            color: cStyle.c4,
            fontSize: cStyle.tTextViewHeadlineFiveFontSizeOn,
            fontWeight: cStyle.tTextViewHeadlineFiveFontWeightOn,
          }),
          className: "x795",
          key: "1",
        }),
      ],
      className: ui.join(this.props.className, "IconViewWithText x38e hc h"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function IconViewWithText(props: IconViewWithTextProps) {
  return React.createElement(_IconViewWithTextState, {
    ..._IconViewWithTextState.defaultProps,
    ...props,
  });
}
